import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import WellnessPageMainContainer from '../../components/wellness/WellnessPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import WellnessPageHeader from '../../components/wellness/WellnessPageHeader';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  wellnessPageAdditionalMeta,
  wellnessPageStructuredData,
} from '../../utils/data/MetaData';

const WellnessPage = React.memo(() => {
  usePageTracking();

  return (
    <>
      <HelmetItem
        PageName='Wellness'
        desc={`${CompanyName} — Mindset & Lifestyle Coaching to help you break free from limits and create a life you love. Tailored coaching plans with weekly check-ins, offered online, 1:1, and for groups. From 2500 per month.`}
        keywords={`Siv Renate, ${CompanyName}, wellness coaching, mindset coaching, lifestyle coaching, tailored coaching plans, weekly check-ins, online coaching, 1:1 coaching, group coaching, Drammen Norway, worldwide`}
        additionalMeta={wellnessPageAdditionalMeta}
        structuredData={wellnessPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation + header */}
          <div className='grid relative grid-rows-reg min-h-screen h-screen max-h-screen'>
            <Navbar />
            <WellnessPageHeader />
          </div>

          {/* Main page content */}
          <WellnessPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
});

export default WellnessPage;
